import { BufferAttribute, BufferGeometry, Shape, Vector3 } from "three";
import { camera } from "../camera";
export const SPEECH_BUBBLE_ANCHOR_POINT_OFFSET = new Vector3(0.1, 0.15, 0.3);
export function roundedRect(x, y, width, height, radius) {
    const shape = new Shape();
    shape.moveTo(x, y + radius);
    shape.lineTo(x, y + height - radius);
    shape.quadraticCurveTo(x, y + height, x + radius, y + height);
    shape.lineTo(x + width - radius, y + height);
    shape.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
    shape.lineTo(x + width, y + radius);
    shape.quadraticCurveTo(x + width, y, x + width - radius, y);
    shape.lineTo(x + radius, y);
    shape.quadraticCurveTo(x, y, x, y + radius);
    return shape;
}
export function createSpeechBubbleArrowGeometry(anchorObjectPosition, anchorTooltipPosition, sizeOfTextBubble, scale) {
    const cameraWorldDirection = camera.perspectiveCam.getWorldDirection(new Vector3());
    const cameraWorldUp = camera.perspectiveCam.up.clone();
    const cameraWorldRight = cameraWorldDirection.cross(cameraWorldUp).normalize().multiplyScalar(0.2);
    const anchorToAnchorVector = anchorTooltipPosition.clone().sub(anchorObjectPosition);
    let anchorTooltipPositionMinus;
    let anchorTooltipPositionPlus;
    if (Math.abs(anchorToAnchorVector.x) < Math.abs(anchorToAnchorVector.y)) {
        anchorTooltipPositionMinus = anchorTooltipPosition
            .clone()
            .add(cameraWorldRight.clone().multiplyScalar(0.1).multiplyScalar(sizeOfTextBubble.x).multiplyScalar(scale));
        anchorTooltipPositionPlus = anchorTooltipPosition
            .clone()
            .sub(cameraWorldRight.clone().multiplyScalar(0.1).multiplyScalar(sizeOfTextBubble.x).multiplyScalar(scale));
    }
    else {
        anchorTooltipPositionMinus = anchorTooltipPosition
            .clone()
            .add(cameraWorldUp.clone().multiplyScalar(0.1).multiplyScalar(sizeOfTextBubble.y).multiplyScalar(scale));
        anchorTooltipPositionPlus = anchorTooltipPosition
            .clone()
            .sub(cameraWorldUp.clone().multiplyScalar(0.1).multiplyScalar(sizeOfTextBubble.y).multiplyScalar(scale));
    }
    const vertices = new Float32Array([
        anchorObjectPosition.x,
        anchorObjectPosition.y,
        anchorObjectPosition.z, // vertex 1
        anchorTooltipPositionMinus.x,
        anchorTooltipPositionMinus.y,
        anchorTooltipPositionMinus.z, // vertex 2
        anchorTooltipPositionPlus.x,
        anchorTooltipPositionPlus.y,
        anchorTooltipPositionPlus.z // vertex 3
    ]);
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new BufferAttribute(vertices, 3));
    return geometry;
}
